export function state(initialState) {
  return {
    sidebarExpanded: true
  };
}
